import { render } from "./BodyRow.vue?vue&type=template&id=1e0c3522"
import script from "./BodyRow.vue?vue&type=script&lang=js"
export * from "./BodyRow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__